import { render, staticRenderFns } from "./edit-config.vue?vue&type=template&id=25a3b288&"
import script from "./edit-config.vue?vue&type=script&lang=ts&"
export * from "./edit-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports